import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { fetchDepotAssets, fetchDepots, fetchDoorStatus, fetchThings } from '../../action/depotsCommands';
import { fetchLocations } from '../../action/locationsCommands';
import { Depot } from '../../api/types';
import { makeDepotSelector } from '../../selector/depotsSelector';
import DepotInfo from './DepotInfo';
import DoorListWidget from './DoorListWidget';

const DepotDetailsPage = () => {
    const dispatch = useDispatch();
    const params = useParams<{ depotId: string }>();
    const depotId = params.depotId ?? '';
    const depot: Depot|undefined = useSelector(makeDepotSelector(depotId));

    useEffect(() => {
        if (!depot) {
            dispatch(fetchDepots({}));
            dispatch(fetchLocations({}));
        }

        dispatch(fetchThings({}));
        dispatch(fetchDepotAssets({ depotId }));
        dispatch(fetchDoorStatus({ depotId }));
    }, []);

    if (!depot) {
        return null;
    }

    return (
        <DoorListWidget depot={depot}>
            <DepotInfo depot={depot} />
        </DoorListWidget>
    );
};

export default DepotDetailsPage;
